import React from 'react'
import { INGREDIENT_TYPES } from 'src/constants';
import { IconButton, SvgIcon, Typography } from '@mui/material';
import PsychologyIcon from '@mui/icons-material/Psychology';
import AR from 'src/icons/AR.svg'
import Audio from 'src/icons/Audio.svg'
import Detect from 'src/icons/Detect.svg'
import Generate from 'src/icons/Generate.svg'
import Produce from 'src/icons/Produce.svg'
import Video from 'src/icons/Video.svg'
import './IngredientCategoryButton.scss'


type IngredientCategoryButtonProps = {
    active: boolean;
    category: number;
    onSelect?: any;
    title: string;
    useCount?: number;
}

const IngredientCategoryButton = (props: IngredientCategoryButtonProps) => {
    const { active, category, title } = props
    const handleSelect = () => {
        props.onSelect(category)
    }
    return (
        <IconButton
            className="category-button"
            data-active={active}
            onClick={handleSelect}
        >
            <IngredientCategoryIcon category={category} />
            <Typography variant="caption">{title}</Typography>
        </IconButton>
    )
}

export type IngredientCategoryIconProps = {
    category: number
}

const IngredientCategoryIcon = (props: IngredientCategoryIconProps) => {
    const category = props.category
    let svg: any = undefined
    let height, width = 40
    let marginBottom = 0
    if (category == INGREDIENT_TYPES.VIDEO) { svg = Video }
    else if (category == INGREDIENT_TYPES.AUDIO) { svg = Audio }
    else if (category == INGREDIENT_TYPES.DETECT) { svg = Detect; height = 55; width = 55; marginBottom = -10 }
    else if (category == INGREDIENT_TYPES.GENERATE) { svg = Generate }
    else if (category == INGREDIENT_TYPES.AR) { svg = AR ; height = 30; width = 30 }
    else if (category == INGREDIENT_TYPES.QUIZZING) { svg = PsychologyIcon; height = 35; width = 35; }
    else { svg = Produce; height = 30; width = 30 }
    return <img src={svg} height={height} width={width} style={{ marginBottom, marginTop : marginBottom }} />
    // Better implementation for uniform svg icons
    return (
        // @ts-ignore
        <SvgIcon component={svg} />

    )
}

export default IngredientCategoryButton